module.exports = __webpack_public_path__ + "img/stvincentandthegrenadines.7b843b18.svg";